/**
 * Маппинг типов связей между моделью бэка (`dep_type` enum) и DHTMLX Gantt
 * (`link.type` строки '0'/'1'/'2'). Также короткие русские обозначения для
 * UI: КН (finish-to-start), НН (start-to-start), КК (finish-to-finish).
 *
 * НК (start_to_finish) намеренно НЕ поддерживается — у бэка он не реализован
 * (см. enum DepType в backend/app/models/dependency.py), и Руслан в плане
 * 2026-05-04 указал, что такой тип ему не нужен.
 *
 * Memory: DHTMLX state.id и link.type — string, наши *_id и dep_type —
 * number/enum. Не сравнивать через === без приведения. Эта функция всегда
 * возвращает enum-строку или валидный link-type-string.
 */

export const DEP_TYPE_TO_LINK = {
  finish_to_start:  '0',
  start_to_start:   '1',
  finish_to_finish: '2',
};

export const LINK_TO_DEP_TYPE = {
  0: 'finish_to_start',
  1: 'start_to_start',
  2: 'finish_to_finish',
  // '3' = start_to_finish — не маппим, fallback в коде на finish_to_start.
};

export const DEP_TYPE_RU = {
  finish_to_start:  'КН',
  start_to_start:   'НН',
  finish_to_finish: 'КК',
};

// Парсер коротких маркеров из inline-edit Pred/Succ. Любой регистр и латинский
// аналог — чтобы не зависеть от раскладки. КН/FS = finish_to_start.
export const RU_TO_DEP_TYPE = {
  КН: 'finish_to_start', FS: 'finish_to_start',
  НН: 'start_to_start',  SS: 'start_to_start',
  КК: 'finish_to_finish', FF: 'finish_to_finish',
};

export function dhtmlxLinkTypeToDepType(linkType) {
  // link.type from DHTMLX events может быть string '0'/'1'/'2' или number 0/1/2.
  const key = String(linkType ?? '0');
  return LINK_TO_DEP_TYPE[key] ?? 'finish_to_start';
}

export function depTypeToDhtmlxLinkType(depType) {
  return DEP_TYPE_TO_LINK[depType] ?? '0';
}

export function depTypeShortRu(depType) {
  return DEP_TYPE_RU[depType] ?? 'КН';
}
